import { useQuery } from 'hooks/useQuery'

import { filterPostsWithTags } from 'utils/queries/posts'

import { Post } from 'types/post'
import { TagGroup } from 'types/workoutTag'

export const useWorkoutTagsFilter = (query: TagGroup[]) => {
  const results = useQuery<Array<Post>>(['workoutTagsFilter', query], () => {
    return filterPostsWithTags(query)
  })

  return {
    results: results.data ?? [],
    isLoading: results.isLoading,
  }
}
